import React from "react";
import { URL_DATA_FEEDS } from "../../constants";

interface DataFeedProps {
	notAvailableDisclaimer?: string;
	packageName: string;
}

export function DataFeed({
	notAvailableDisclaimer,
	packageName,
}: DataFeedProps) {
	let content: React.ReactNode;

	if (notAvailableDisclaimer) {
		content = (
			<div className="typography">
				<p>{notAvailableDisclaimer}</p>
			</div>
		);
	} else {
		content = (
			<>
				<div className="typography">
					<p>
						{packageName} data is available in a data feed form,
						ready for seamless integration into CRMs, AI models,
						data lakes, operational systems, Power BI, and more.
					</p>
					<ul className="ticks ticks--small">
						<li>Comprehensive Data Dictionary included</li>
						<li>Several delivery formats available</li>
						<li>Sample datasets provided for validation</li>
						<li>
							Flexible for integration into CRMs, AI models, or
							operational tools
						</li>
					</ul>
				</div>
				<a
					className="btn btn--tertiary"
					target="_blank"
					href={URL_DATA_FEEDS}
					rel="noreferrer"
				>
					Learn more
				</a>
			</>
		);
	}

	return (
		<div className="subscription__data-feed grid__col-lg-4 grid__col-12">
			<p className="h4">Data feed</p>
			{content}
		</div>
	);
}
